var DocumentPositions = {
  DOCUMENT_POSITION_DISCONNECTED: 1,
  DOCUMENT_POSITION_PRECEDING: 2,
  DOCUMENT_POSITION_FOLLOWING: 4,
  DOCUMENT_POSITION_CONTAINS: 8,
  DOCUMENT_POSITION_CONTAINED_BY: 16,
  DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC: 32
};

if (Object.freeze) {
  Object.freeze(DocumentPositions);
}

export default DocumentPositions;
//# sourceMappingURL=DocumentPositions.js.map